import type { TagDefinition, TagRegistry } from './tagRegistry'

/**
 * Canonical root tag for book characters ("דמויות") in The Last Human Manifesto.
 * Stable id from manifesto-content/books/the-last-human-manifesto/tags.json — do not remove from the registry.
 */
export const CHARACTERS_ROOT_TAG_ID = 'tag_13r7uso'

export const CHARACTERS_ROOT_DISPLAY_NAME = 'דמויות'

/** Default definition used when restoring the tag if missing from a write payload. */
export const CHARACTERS_ROOT_TAG_DEFAULT: TagDefinition = {
  name: CHARACTERS_ROOT_DISPLAY_NAME,
  parentIds: [],
  color: '#C98F7C',
  order: 30,
}

export function ensureProtectedCharacterTags(registry: TagRegistry): TagRegistry {
  const tags = { ...registry.tags }
  if (!tags[CHARACTERS_ROOT_TAG_ID]) {
    tags[CHARACTERS_ROOT_TAG_ID] = { ...CHARACTERS_ROOT_TAG_DEFAULT }
  }
  return { ...registry, tags }
}
